import React from 'react';

import {
  useApproveSA,
  useDeleteSA,
  useMoreInfoSA,
  useRejectSA,
  useUndoSA,
} from '../../data';
import Actions from './Actions';
import { useScreenGo } from '@gogame/screens';
const SAActions = ({
  actions,
  data,
  onEdit,
  onCopy,
  onDelete,
  withViewLog = true,
}) => {
  const [deleteSA] = useDeleteSA();
  const [approveSA] = useApproveSA();
  const [moreInfoSA] = useMoreInfoSA();
  const [rejectSA] = useRejectSA();
  const [undoSA] = useUndoSA();
  const go = useScreenGo();

  const handleDelete = async () => {
    await deleteSA(data);
    onDelete?.(data);
  };

  const handleApprove = () => {
    approveSA(data);
  };

  const handleMoreInfo = () => {
    moreInfoSA(data);
  };

  const handleReject = () => {
    rejectSA(data);
  };

  const handleUndo = () => {
    undoSA(data);
  };

  const handleCopy = () => {
    onCopy(data)?.then((response) => {
      go(response.id);
    });
  };

  const handleViewLog = () => {
    const { id } = data;
    go(id, {
      state: { activeTabId: 'Actions Log' },
    });
  };

  const handleEdit = () => onEdit?.(data);

  return (
    <Actions
      actions={actions}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onApprove={handleApprove}
      onMoreInfo={handleMoreInfo}
      onReject={handleReject}
      onUndo={handleUndo}
      onCopy={handleCopy}
      onViewLog={handleViewLog}
      withViewLog={withViewLog}
    />
  );
};

export default SAActions;
